<template>
  <div>
    <b-card>
      <b-row class="mb-1">
        <b-col md="4">
          <v-select v-model="filterBand" :options="optionsBand" :loading="loadingFilter" label="text" placeholder="Cari" />
        </b-col>
        <b-col class="text-right">
          <b-button variant="primary" @click="addItems()" v-ripple.400="'rgba(255, 255, 255, 0.15)'">
            Tambah
          </b-button>
        </b-col>
      </b-row>

      <BaseTable
        :fields="fields"
        :items="items"
        :loading="loading"
        :rows="pagination.total"
        :perPage="filter.size"
        :currentPage="filter.page"
        :edit-item="updateItems"
        :detail-item="viewItems"
        :delete-item="deleteItems"
        :handle-page-change="handlePageChange"
      />

      <BasicSalaryComponent
        :page-title="pageTitle"
        :loading="loadingSave"
        :edit-id="editId"
        :formPayload="formPayload"
        :create-item="createdItems"
        :isView="isView"
        :update-item="sendUpdateItems"
      />
    </b-card>
  </div>
</template>

<script>
import _ from "lodash";
import Ripple from "vue-ripple-directive";
import BaseTable from "@/components/BaseTable.vue";
import { BCard, BRow, BCol, BButton, BFormInput } from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import BasicSalaryComponent from '../../components/BasicSalary/BasicSalaryComponent';
import { BasicSalaryServices } from '../../services/basic-salary.service';
import { successNotification, errorNotification } from "@/auth/utils";
import utility from '../../libs/utility';
import vSelect from "vue-select";
import { BandServices } from '../../services/band.service'
export default {
  name: "MasterBasicSalary",
  components: {
    BaseTable,
    BCard,
    BRow,
    BCol,
    BButton,
    BFormInput,
    ValidationProvider,
    ValidationObserver,
    BasicSalaryComponent,
    vSelect
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      pageTitle: 'Master Gaji Pokok',
      isView: false,
      fields: [
        {
          key: 'no',
          label: "No",
        },
        {
          key: 'totalYear',
          label: 'Tahun'
        },
        {
          key: 'band',
          label: 'Level Band'
        },
        {
          key: 'amount',
          label: 'Nilai Gapok'
        },
        {
          key: 'actions',
          label: 'Akses'
        }
      ],
      items: [],
      loading: false,
      loadingSave: false,
      loadingFilter: false,
      filterBand: null,
      optionsBand: false,
      pagination: {
        total: 0
      },
      filter: {
        title: "",
        page: 1,
        size: 10
      },
      editId: null,
      formPayload: Object
    }
  },
  watch: {
    filter: {
      handler: _.debounce(function (value) {
        this.GetBasicSalary();
      }, 300),
      deep: true,
    },
    'filterBand': function () {
      this.filter.page = 1;
      this.GetBasicSalary();
    }
  },
  methods: {
    cleanForm() {
      this.editId = null;
      this.isView = false;
      this.formPayload    =   {
        years: '',
        levelBand: '',
        valueGapok: ''
      };
    },
    handlePageChange(value) {
      this.loading = true
      this.filter.page = value;
    },
    async GetBasicSalary() {
      this.loading  =  true;
      this.items    =  [];
      let req = {
        page: this.filter.page,
        size: this.filter.size
      };
      if (this.filterBand !== null) {
        req['bandId'] = this.filterBand.value.bandId;
      }
      try {
        await BasicSalaryServices.find(req)
          .then((result) => {
            window.console.log(result);
            result.data.content.forEach((item) => {
              item['amount'] = item.salaryAmount;
              this.items.push(item);
            });
            this.pagination.total  =  result.data.total;
            this.loading  =  false;
          })
          .catch((e) => {
            this.loading  =  false;
            return errorNotification(this,"Oops!", e.message);
          });
      } catch (e) {
        this.loading  = false;
      }
    },
    addItems() {
      this.$bvModal.show("form-basic-salary");
      this.cleanForm();
    },
    deleteItems(data) {
      window.console.log(data);
      this.$swal({
        title: "Anda yakin?",
        text: "Anda yakin ingin menghapus data ini?",
        icon: "warning",
        showCancelButton: true,
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.loading = true;
          try {
            await BasicSalaryServices.delete(data.id)
              .then((result) => {
                  if (utility.ResponseStatus(result)) {
                    this.$bvModal.hide("form-basic-salary");
                    this.loading = false;
                    this.GetBasicSalary();
                    successNotification(this, "Success",result.statusMessage);
                  }
              }).catch((e) => {
                  errorNotification(this, "Oops!", e.message);
                  this.loading = false;
              });
          } catch (e) {
            errorNotification(this, "Oops!", e.message);
            this.loading = false;
          }
        }
      });
    },
    updateItems(data) {
      this.isView = false;
      this.$bvModal.show("form-basic-salary");
      this.formPayload   =  {
        years: data.totalYear,
        levelBand: {
          text: data.band.bandName,
          value: data.band
        },
        valueGapok: data.amount
      };
      this.editId  =  data.id;
    },
    async sendUpdateItems() {
      let req = {
        bandId: this.formPayload.levelBand.value.bandId,
        salaryAmount: parseInt(this.formPayload.valueGapok),
        totalYear: parseInt(this.formPayload.years)
      };
      this.loadingSave = true;
      try {
        await BasicSalaryServices.update(this.editId, req)
          .then((result) => {
            if (utility.ResponseStatus(result)) {
              this.$bvModal.hide("form-basic-salary");
              this.loadingSave =  false;
              this.cleanForm();
              this.GetBasicSalary();
              successNotification(this, "Success",result.statusMessage);
            }
          })
          .catch((e) => {
            errorNotification(this, "Oops!", e.message);
            this.loadingSave = false;
          });
      } catch (e) {
        errorNotification(this, "Oops!", e.message);
        this.loadingSave = false;
      }
    },
    viewItems(data) {
      window.console.log(data);
      this.isView = true;
      this.formPayload   =  {
        years: data.totalYear,
        levelBand: {
          text: data.band.bandName,
          value: data.band
        },
        valueGapok: data.amount
      };
      this.$bvModal.show("form-basic-salary");
    },
    async createdItems() {
      this.loadingSave =  true;
      let req  =  {
        bandId: this.formPayload.levelBand.value.bandId,
        salaryAmount: parseInt(this.formPayload.valueGapok),
        totalYear: parseInt(this.formPayload.years)
      };
      window.console.log(req);
      try {
        await BasicSalaryServices.create(req)
          .then((result) => {
            window.console.log(result);
            if (utility.ResponseStatus(result)) {
              this.$bvModal.hide("form-basic-salary");
              this.loadingSave =  false;
              this.cleanForm();
              this.GetBasicSalary();
              successNotification(this, "Success",result.statusMessage);
            }
          })
          .catch((e) => {
            this.loadingSave =  false;
            errorNotification(this, "Oops!", e.message);
          });
      } catch (e) {
        errorNotification(this, "Oops!", e.message);
        this.loadingSave =  false;
      }
    },
    async GetLeveBand() {
      this.loadingFilter = true;
      let req = {
        page: 1,
        size: 100
      };
      this.optionsBand = [];
      await BandServices.findAll(req)
        .then((result) => {
          window.console.log(result);
          if (result.code === "00") {
            result.data.content.forEach((items) => {
              this.optionsBand.push({
                text: items.bandName,
                value: items
              });
            })
          } else {
            errorNotification(this, "Oops!", result.message);
          }
          this.loadingFilter = false;
        })
        .catch((e) => {
          errorNotification(this, "Oops!", e.message);
          this.loadingFilter = false;
        });
    },
  },
  mounted() {
    this.GetBasicSalary();
    this.GetLeveBand();
  }
}
</script>
<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
</style>
